import React, { FC } from 'react';
import { SelectListWrapper } from '~ComponentsImproved/SelectList';
import SelectListItem from '~ComponentsImproved/SelectList/SelectListItem';

export interface ListItem {
  id: string;
  name: string;
}

interface Props {
  list: ListItem[];
  selectedIds?: string[] | null;
  onSelect: (id: string) => void;
  dark?: boolean;
  grid?: boolean;
}

const SelectListMulti: FC<Props> = ({
  list,
  selectedIds,
  onSelect,
  dark = false,
  grid = false,
}) => {
  return (
    <SelectListWrapper dark={dark} grid={grid}>
      {list.map((item) => {
        const isActive = selectedIds?.includes(item.id) ?? false;

        return (
          <SelectListItem
            key={item.id}
            id={item.id}
            name={item.name}
            active={isActive}
            onSelect={onSelect}
            dark={dark}
          />
        );
      })}
    </SelectListWrapper>
  );
};

export default SelectListMulti;
